<section class="pt-2">
  <h2 class="mt-2 mb-2">Resource info</h2>

  <div *ngIf="!isEditMode" class="d-flex flex-row align-items-center">
    <tr-icon [icon]="icon.infoHeavy" class="pr-2 info"></tr-icon>
    <p class="mb-0 user-select-none">You may select existing tables (not in Floorplan) or create new ones.</p>
  </div>

  <form [formGroup]="form" class="pt-2" *ngIf="form !== undefined">
    <div class="form-group" *ngIf="!isEditMode">
      <tablesready-btn-group-control
        class="mb-3"
        id="resource-option"
        bindName="name"
        bindValue="value"
        [control]="resourceSelectModeControl"
        [items]="resourceOptions"
        [buttonType]="buttonGroupColors.success"
        (btnClick)="resourceSelectModeChange($event)"
      ></tablesready-btn-group-control>
    </div>

    <div class="form-group">
      <label class="table-label floorplan-builder-label user-select-none">Resource name</label>
      <frontend-dropdown
        *ngIf="!isEditMode && resourceSelectModeControl?.value === resourceSelectModeEnum.Existing"
        [multiple]="false"
        [items]="availableResources"
        [clearable]="true"
        (ngModelChange)="resourceChangeById($event)"
        elementId="table-name"
        bindValue="_id"
        bindLabel="name"
        formControlName="resourceId"
        placeholder="Select an existing resource"
        noItemsText="No available resources. Create a new one"
      ></frontend-dropdown>

      <input
        *ngIf="isEditMode || resourceSelectModeControl?.value === resourceSelectModeEnum.New"
        type="text"
        class="form-control"
        formControlName="resourceName"
        placeholder="Enter resource name"
        required
      />

      <control-messages [control]="resourceIdControl"></control-messages>
      <control-messages [control]="resourceNameControl"></control-messages>
    </div>

    <div class="row form-group">
      <div class="col form-group">
        <label for="table-min-capacity" class="table-label floorplan-builder-label user-select-none">Capacity Min</label>
        <input
          #minInput
          id="table-min-capacity"
          class="form-control"
          type="number"
          formControlName="minCapacity"
          [min]="minCapacityValue"
          [max]="maxCapacityControl.value"
          (blur)="checkMinCapacity(minCapacityControl.value)"
          (change)="capacityChange(minInput.value, maxInput.value)"
        >
        <control-messages [control]="minCapacityControl"></control-messages>
      </div>

      <div class="col form-group">
        <label for="table-max-capacity" class="table-label floorplan-builder-label user-select-none">Capacity Max</label>
        <input
          #maxInput
          id="table-max-capacity"
          class="form-control"
          type="number"
          formControlName="maxCapacity"
          [min]="minCapacityControl.value"
          (blur)="checkMaxCapacity(maxCapacityControl.value)"
          (change)="capacityChange(minInput.value, maxInput.value)"
        >
        <control-messages [control]="maxCapacityControl"></control-messages>
      </div>
    </div>

    <div class="form-group d-flex flex-row justify-content-between mb-0">
      <label class="control-label user-select-none">Full resource info</label>
      <a (click)="changeInfoVisibility()"><tr-icon [icon]="fullInfoVisible ? icon.arrowUp : icon.arrowDown"></tr-icon></a>
    </div>

    <div class="w-100" *ngIf="fullInfoVisible">
      <div class="form-group" formGroupName="availability">
        <div class="table-label floorplan-builder-label mb-2 user-select-none">Availability</div>
        <div class="d-flex flex-column">
          <div class="d-flex flex-row align-items-center justify-content-between">
            <p class="mb-0">Public Check-In</p>
            <input type="checkbox" formControlName="publicCheckIn" />
          </div>

          <div class="d-flex flex-row align-items-center justify-content-between">
            <p class="mb-0">Reservations/Appointments</p>
            <input type="checkbox" formControlName="reservations" />
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="table-label floorplan-builder-label user-select-none">Service</label>
        <frontend-dropdown
          [items]="services"
          elementId="serviceDropdown"
          bindLabel="name"
          bindValue="_id"
          placeholder="Choose service"
          formControlName="service"
          [multiple]="true"
          [clearable]="true"
        ></frontend-dropdown>

        <control-messages [control]="serviceControl"></control-messages>
      </div>

      <div class="form-group">
        <label class="table-label floorplan-builder-label user-select-none">Section (optional)</label>
        <frontend-dropdown
          [items]="sections"
          bindLabel="name"
          bindValue="id"
          elementId="sectionsDropdown"
          placeholder="Choose section"
          formControlName="sectionId"
          [multiple]="false"
          [clearable]="true"
        ></frontend-dropdown>
      </div>
    </div>

    <div class="form-group mb-0">
      <label class="control-label floorplan-builder-label user-select-none">Element info</label>
    </div>

    <div class="form-group">
      <label for="table-size" class="table-label floorplan-builder-label user-select-none">Size</label>
      <tablesready-btn-group-control
        id="table-size"
        bindName="name"
        bindValue="value"
        [control]="form?.get('size')"
        [items]="tableInfoData.sizes"
        [buttonType]="buttonGroupColors.success"
        (btnClick)="sizeChanged.emit($event)"
      ></tablesready-btn-group-control>
    </div>

    <div class="form-group">
      <label for="table-shape" class="table-label floorplan-builder-label user-select-none">Shape</label>
      <tablesready-btn-group-control
        id="table-shape"
        bindName="name"
        bindValue="value"
        [control]="form?.get('shape')"
        [items]="tableInfoData.shapes"
        [buttonType]="buttonGroupColors.success"
        (btnClick)="shapeChanged.emit($event)"
      ></tablesready-btn-group-control>
    </div>

    <div class="form-group">
      <label class="table-label floorplan-builder-label user-select-none">Rotate table</label>
    </div>

    <div class="form-group d-flex flex-row align-items-center">
      <div class="d-flex flex-row align-items-center">
        <p class="mb-0 pr-2 user-select-none">ANGLE</p>

        <input
          type="number"
          step="1"
          formControlName="rotation"
          placeholder="Enter rotation angle"
          class="form-control rotation-angle"
          (change)="angleChanged(form.get('rotation'), rotationAngleChanged)"
        />
      </div>
      <a (click)="resetAngle()">Reset</a>
    </div>

    <div class="d-flex flex-row justify-content-between align-items-center">
      <button
        *ngIf="isEditMode"
        (click)="duplicateTable(tableId)"
        class="btn btn-link-info user-select-none"
        [ngbTooltip]="disableDuplicateBtnTooltip"
        [disabled]="form.touched"
      >Duplicate table</button>
      <button
        *ngIf="isEditMode"
        (click)="delete(tableId)"
        class="btn btn-link-danger user-select-none"
      >Delete table</button>
    </div>

    <div class="d-flex justify-content-between mt-4">
      <div class="form-group col mb-0 pl-0">
        <button class="btn btn-info w-100 user-select-none" [disabled]="!this.form.valid || (isEditMode ? !form.touched : false)" (click)="saveTable()">{{ isEditMode ? 'Save' : 'Add' }}</button>
      </div>

      <div class="form-group col mb-0 pr-0">
        <button class="btn btn-danger w-100 user-select-none" (click)="cancel()">Cancel</button>
      </div>
    </div>
  </form>
</section>
